<div class="wk-root-container" [class.showDragging]="dragging()">
    <wk-navbar />
    <div class="wk-router-outlet-container" [class.bannerShown]="bannerIsShown">
        <div class="wk-card-view__wrapper">
            <div class="wk-card-view__counters-section--wrapper container-fluid wk-view__counters-position">
                <div>
                    <app-header-component />
                </div>
                <div class="wk-card-view__columns--list">
                    <router-outlet />
                </div>
                @if (showCardDownload) {
                    <div class="wk-view__active-card-loading-overlay spinningWheelOverlayCssClass">
                        <app-loader text="General.LoadingCards" [isOverlay]="false" [size]="'medium'" />
                    </div>
                }
            </div>
        </div>
        @if (spinnerRequested) {
            <app-loader text="" size="large" />
        }
    </div>
</div>
